export interface DataItem {
    key: string;
    datum: string;
    uzivatel: string;
    zeme: string;
    flagCode: string;
    kategorie: string;
    nabidka: string;
    typ: string;
    id: string;
    odmena: string;
    castka: string;
}

export const data: DataItem[] = [
    {
        key: "1",
        datum: "20.02.2022 09:30",
        uzivatel: "Jean Dupont",
        zeme: "Francie",
        flagCode: "fr",
        kategorie: "Finance",
        nabidka: "BNP Paribas",
        typ: "iFrame",
        id: "230",
        odmena: "200",
        castka: "8,765.43",
    },
    {
        key: "2",
        datum: "22.02.2022 11:15",
        uzivatel: "Lars Hansen",
        zeme: "Dánsko",
        flagCode: "dk",
        kategorie: "Finance",
        nabidka: "Danske Bank",
        typ: "Lead",
        id: "231",
        odmena: "220",
        castka: "10,432.10",
    },
    {
        key: "3",
        datum: "25.02.2022 10:50",
        uzivatel: "Giovanni Rossi",
        zeme: "Itálie",
        flagCode: "it",
        kategorie: "Finance",
        nabidka: "UniCredit",
        typ: "Click",
        id: "232",
        odmena: "210",
        castka: "7,654.32",
    },
    {
        key: "4",
        datum: "27.02.2022 13:40",
        uzivatel: "Emma Svensson",
        zeme: "Švédsko",
        flagCode: "se",
        kategorie: "Finance",
        nabidka: "SEB",
        typ: "Lead",
        id: "233",
        odmena: "195",
        castka: "9,876.54",
    },
    {
        key: "5",
        datum: "01.03.2022 16:30",
        uzivatel: "Patryk Kowalski",
        zeme: "Polsko",
        flagCode: "pl",
        kategorie: "Finance",
        nabidka: "PKO Bank",
        typ: "iFrame",
        id: "234",
        odmena: "180",
        castka: "6,789.01",
    },
];
